import { render, staticRenderFns } from "./RidersSliderItem.vue?vue&type=template&id=e73f4a4a&lang=pug&"
import script from "./RidersSliderItem.vue?vue&type=script&lang=js&"
export * from "./RidersSliderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports